import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { AuthProvider } from "./lib/auth.tsx";
import { RouterProvider } from "./lib/router.tsx";
import { SURFACE_NAMES, surface } from "./lib/surface.ts";
import "./theme.css";
import "./app.css";

// The surface picks the accent, and the tab title says which site you are on.
document.documentElement.dataset.surface = surface;
document.title = SURFACE_NAMES[surface];

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </RouterProvider>
  </StrictMode>,
);
